module.exports = __webpack_public_path__ + "img/HP-01.a8f64529.png";